<template>
    <DataLabel
        :item="attachment"
        :hide-icon="hideIcon"
        icon-class="fa fa-fw fa-paperclip"
        :none="$t( 'attachments.nil' )"
        :href="href"
        href-in-new-window>
        <small v-if="hasSize" class="badge badge-light ml-1">{{ attachment.size | sizeOf }}</small>
        <DateLabel v-if="hasTimestamp" class="text-muted small ml-1 text-nowrap" :date="attachment.created_at" />
    </DataLabel>
</template>

<script>
import DataLabel from '@/js/components/common/labels/DataLabel';
import DateLabel from '@/js/components/common/labels/DateLabel';

export default {
    name: 'AttachmentLabel',

    components: {DataLabel, DateLabel},

    props: {
        attachment: {type: [String, Object], required: true},
        publication: {type: Object, default: null},
        document: {type: Object, default: null},
        hideIcon: {type: Boolean},
        noLink: {type: Boolean},
    },

    computed: {
        hasSize() {
            return this.attachment && Number.isFinite(this.attachment.size);
        },

        hasTimestamp() {
            return this.attachment && !!this.attachment.created_at;
        },

        href() {
            if (this.noLink) {
                return undefined;
            }

            if (!this.attachment) {
                return undefined;
            }

            if (!this.attachment.download_url) {
                return undefined;
            }

            return this.attachment.download_url;
        },
    },
};
</script>
